import { Component, ChangeDetectorRef, ViewChild, Inject, ElementRef} from '@angular/core';
import { HttpResponse, HttpEventType, HttpHeaderResponse } from '@angular/common/http';
import { ImportRKImageService } from './importrkimage.service';
import { ConfirmService } from '../shared/confirm/confirm.service';
import { AppService } from '../app.service';
import { ActivatedRoute } from '@angular/router'; 
import { FileUploader, FileLikeObject } from 'ng2-file-upload';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { PersonFormService } from '../PersonComponent/PersonFormComponent/person.form.service';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { Countries } from '../shared/countries/countries';
import { EmployerViewService } from '../EmployerComponent/EmployerViewComponent/employer.view.service';
import { NewRegisterFormService } from '../RegisterComponent/NewRegisterFormComponent/new.register.form.service';
import { Formvalidator } from '../RegisterComponent/NewRegisterFormComponent/new.register.form.formvalidator';
import { formatDate } from '@angular/common';
import { ValidationModalComponent } from '../shared/views/ValidationModalComponent/validation.modal.component';
import { ConflictHandlerModalComponent } from '../shared/views/ConflictHandlerModalComponent/conflict.handler.modal.component'
import { Globals } from '../globals';
import translateJson from "../../translate.json";
import customerJson from "../../assets/config/customer.json";
import { ImportConflict } from '../models/import-conflict';
import { EmployerFormService } from '../EmployerComponent/EmployerFormComponent/employer.form.service';
import { SuaStatusType } from '../shared/enum/SuaStatusType';
import { DateUpdateFix } from '../models/date-update-fix';
import { AuthenticationService } from '../auth';
import { KeyValue } from '@angular/common';
import { DOCUMENT } from '@angular/common';
import { PrintStyling } from 'app/models/print-styling';

enum otherTypeEnum {SUCCESSFULLIST, FAILEDLIST};
@Component({
    selector: 'importrkimage-comp',
    providers: [ImportRKImageService, Formvalidator, ConfirmService, AppService, PersonFormService, Countries, EmployerViewService, NewRegisterFormService, EmployerFormService, DateUpdateFix, AuthenticationService, PrintStyling],
    templateUrl: './importrkimage.component.html',  
    styleUrls: ['./importrkimage.component.css']  
})

export class ImportRKImage {

    selectedFiles: FileList;
    currentFileUpload: FileLikeObject;

    @ViewChild('validationModal') validationModal: ValidationModalComponent;
    @ViewChild('conflictHandlerModal') conflictHandlerModal: ConflictHandlerModalComponent;
    @ViewChild('xmlUploader') xmlUploader: ElementRef;

    // Get translation/text from customerJson
    private i18 = translateJson.i18;
    private importDigitalFileActive: boolean = customerJson.settings.importDigitalFileActive;
    private importOcrFileActive: boolean = customerJson.settings.importOcrFileActive;

    suaStatusType = SuaStatusType;

    percentage : number = 0;
    progressArray: any = [];

    suaAvailable: boolean = false;

    private rkToDisplay: any;
    private person: any;
    private employers: any;
    private uploadFailed: any = [];
    private projects: any = [];
    private fileType: String;
    private personError: any = [];

    arrayOfRkForms: any = [];
    arrayOfPersons: any = [];
    arrayOfEmployers: any = [];
    arrayOfProjects: any = [];
    arrayOfSavedPersons: any = [];

    addressCodeFilterList: any = [];
    addressCodeExists: boolean;

    rkOperatorFilterList: any = [];
    rkRegulatorFilterList: any = [];
    professionsFilterList: any = [];
    professionExists:boolean;

    personSaved: Boolean = false;
    errorInOcr: any = [];
    uploadStarted: Boolean = false;
    error: String;
    duplicates: Boolean;
    modalChoices: any;
    personDetailsForm: FormGroup;
    nationality: FormControl;
    purposeOfControlArray: any [];

    choiceModalForm: FormGroup;
    modalIsReady: Boolean = false;
    showLoader: Boolean = false;
    showXmlImportResultView: Boolean = false;
    importedXmlResult: any = [];
    importXmlReady: Boolean = false;

    public uploader: FileUploader = new FileUploader({ allowedMimeType: ['application/pdf', 'application/xml'] });
    public hasBaseDropZoneOver: boolean = false;
    
    private otherType: String = otherTypeEnum[0];
 
    private importedDataObject = {
        ssn: String,
        occurrence: String,
        employerCode: String,
        referenceNumber: String,
        sapoDate: String,
        uuid: String,
        currentRks: String,
        exists: Boolean
    }

    private importedDataList: any = [];
  
    private activeComponent: boolean;
    private dataRows: any;
    private dataImported = false;
    private dataHasError = false;
    private personsRequireChoice: any;
    public enableDigitalXmlExport: boolean = customerJson.settings.enableDigitalXmlExport;     

    private employerList: any = [];
    customerEmployer: any = {};
    private customerOrgId: string = customerJson.customer.organisationId;
    private customerName: string = customerJson.customer.name;
    private globalOrgAssociations: Boolean = customerJson.settings.globalOrgAssociations;
    autoClearOrgNrOperator: Boolean = customerJson.settings.autoClearOrgNrOperator;
    employerFieldLocked: Boolean = false;
    showEmployerFields: Boolean = true;
    noSuaEmployerArray: any = [];
    selectedCountryList: any = [];


    constructor(
        private service: ImportRKImageService,
        private formValidator: Formvalidator,
        private personService: PersonFormService,   
        private changeDetector: ChangeDetectorRef,
        private employerService: EmployerViewService,
        private rkService: NewRegisterFormService,
        private countries: Countries,
        private activatedRoute: ActivatedRoute,
        private confirmService: ConfirmService,
        private ngxSmartModalService: NgxSmartModalService,
        private appService: AppService,
        private dateUpdateFix: DateUpdateFix,
        private printStyling: PrintStyling,
        private globals: Globals,
        private companyService: EmployerFormService,
        private authService: AuthenticationService,
        @Inject(DOCUMENT) private document: Document)
         {
            this.authService.isAuthenticated();
            this.activeComponent = appService.isComponentActive('importrkimage');
            this.getAllUniqueProfessions();
            this.getAllAddressCodes();
            this.getActiveEmployers();
            this.getActiveAuthorityEmployers();
            this.setDefault();
        }

    ngAfterViewChecked() {        
        this.changeDetector.detectChanges();
    }

    setDefault() {
        this.choiceModalForm = new FormGroup({
            selectedChoice: new FormControl()
        });

        this.nationality = new FormControl;

        this.arrayOfPersons = [];
        this.arrayOfRkForms = [];
        this.uploadFailed = [];
        this.projects = [];
        this.arrayOfProjects = [];
        this.errorInOcr = [];
        this.importedDataList = [];
        this.dataHasError = false;
        this.progressArray.length = 0;
        this.uploadStarted = false;
        this.uploader.clearQueue();
        this.personDetailsForm = this.setDefaultRkView();
        this.fileType = "";
        this.purposeOfControlArray = customerJson.sapoFormValues.purposeOfControlArray;
    }

    /*
    * Method to set the upload type for the file to be read by the system
    * Available params: raw-file, scanned-file
    * @param type Type definition to upload
    **/
    setUploadType(type: String) {
       this.fileType = type;
    }

    setDefaultRkView() {
        return new FormGroup({
            //Person
            ssn: new FormControl(),
            currentCitizenship: new FormControl(),
            personFirstName: new FormControl(),
            purposeOfControl: new FormControl(),
            suaAssignment: new FormControl(),

            operatorName: new FormControl(),
            regulatorName: new FormControl(),
            profession: new FormControl(),
            personLastName: new FormControl(),
            cityOfBirthAbroad: new FormControl(),
            countryOfBirthAbroad: new FormControl(),
            selectedCompany: new FormControl(),
            companySupplier: new FormControl(),
            companySuaProject: new FormControl(),
            employedByCustomer: new FormControl(false),


            //To be filled by user
            oldCitizenship: new FormControl(),
            displayOldCitizenship: new FormControl(),
            phoneDaytime: new FormControl(),
            otherAddress: new FormControl(),
            otherPostalAddress: new FormControl(),
            otherPostalCity: new FormControl(),
            otherPostalCode: new FormControl(),
            passportNumber: new FormControl(),
            latestAddressAbroad: new FormControl(),
            reasonText: new FormControl(),
            lastDate: new FormControl(),
            rkStatus: new FormControl(),

            //Radio's
            securityClass: new FormControl(),
            controlReason: new FormControl(),

            rkRegNumber: new FormControl(),
            rkInternalRegNumber: new FormControl(),
            generateSequenceNumber: new FormControl(false),
            securityInterview: new FormControl(),
            orgNrOperator: new FormControl(),
            adressCodeOperator: new FormControl(),
            orgNrRegulator: new FormControl(),
            addressField1: new FormControl(),
            addressField2: new FormControl(),
            addressField3: new FormControl(),
            addressCodeRegulator: new FormControl(),
            nameClarification: new FormControl()
        });
    }

    selectFile(event) {
        this.selectedFiles = event.target.files;
    }

    fileOverBase(event):  void {
        this.hasBaseDropZoneOver  =  event;
    }

    getFiles(): FileLikeObject[] {
        return this.uploader.queue.map((fileItem) => {
            return fileItem.file;
        });

    }

    clearData() {
        this.progressArray.splice(0, this.progressArray.length)
        this.arrayOfEmployers.splice(0, this.arrayOfEmployers.length);
        this.errorInOcr.splice(0, this.errorInOcr.length);
        this.uploadFailed.splice(0, this.uploadFailed.length);
        this.arrayOfPersons.splice(0, this.arrayOfPersons.length);
        this.arrayOfRkForms.splice(0, this.arrayOfRkForms.length);
        this.arrayOfProjects.splice(0, this.arrayOfProjects.length);
        this.personError.splice(0, this.personError.length);
        this.uploader.clearQueue();
        this.clearForm();
        this.setDefault();
    }

    showButtons() {
        if(this.uploader.queue.length > 0) {
            return true;
        }
        return false;
    }

    /**
    * Go back to the previous view from where we came
    */
    cancelUpload() {
        this.confirmService.confirm(this.i18.import.form.importCancelWarningText)
        .then(result => {
            if(result) {
            this.clearData();
            }
        });
    }

    async upload() {   
        let files = this.getFiles();
        let queueCount = 0;
        while(this.uploader.queue.length > queueCount) {
            this.progressArray.push(this.percentage);
            this.arrayOfRkForms.push(this.setDefaultRkView());
            queueCount++;
        }

        this.uploadStarted = true;
        
        for(let i =0; i < files.length; i++) {
            let formData = new FormData();
            this.currentFileUpload = files[i];
            formData.append('file' , files[i].rawFile, files[i].name);
            this.service.upload(formData).subscribe(event => {
                if(event instanceof HttpHeaderResponse) {
                    if(event.status != 200) {
                        this.uploadFailed[i] = true;
                        return;
                    }
                }
                if (event.type === HttpEventType.UploadProgress) {
                        this.progressArray[i] = Math.round(50 * event.loaded / event.total);
                } else if (event instanceof HttpResponse) {
                    if (this.fileType == 'raw-file') {
                        this.service.startPDF(files[i].name).subscribe(      
                            data => this.setStatus(data, i),
                            error => this.uploadError(i)
                        );
                    } 
                    else if (this.fileType == 'scanned-file') {
                        this.service.startOCR(files[i].name).subscribe(      
                            data => this.setStatus(data, i),
                            error => this.uploadError(i)
                        );
                    }
                    else {
                        this.showErrorMessage(this.i18.import.form.importWrongFileTypeSelected);
                    }
                }
            });     
        }    
    }

            
    /*
    * Uploads the excel file and starts respone process
    */
    startXMLUpload(firstRun: boolean) {
        this.showLoader = true;        
        let currentFileUpload: File;
        currentFileUpload = this.selectedFiles.item(0);
        this.importXmlReady = false;
        this.showLoader = true;
        if(firstRun) {
            this.service.checkExists(currentFileUpload).subscribe(
                data => {
                    this.handleXmlExists(data)
                },
                error => {
                    this.showLoader = false,
                    this.showError(error)
                },
                () => this.showLoader = false
            )
        } else {
            this.service.uploadXML(currentFileUpload).subscribe(
                data => this.setXmlReturnData(data),
                error => {
                    this.showLoader = false,
                    this.showError(error)
                },
                () => this.showLoader = false
            )
        }
    }

    /**
     * if a xml file have ben executed before prompt user to continue or abort.
     * @param data xml import response
     */
    handleXmlExists(data: any) {
        let tmp = data.body != undefined && data.body != null ? data.body : null;
        if(tmp != null && tmp.fileExists !== undefined && tmp.fileExists !== null && tmp.fileExists === true) {
            this.showLoader = false;
            this.ngxSmartModalService.setModalData(tmp, 'xmlExistModal', true);
            this.ngxSmartModalService.getModal('xmlExistModal').open();
        } else if(tmp != null && tmp.fileExists !== undefined && tmp.fileExists !== null && tmp.fileExists === false){
            this.setXmlReturnData(data);
        }
    }

    uploadError(index) {
        this.errorInOcr[index] = true;
    }

    insufficientDataFromPerson(index, data) {
        // Check if we got enough data to show a form
        // This is determined on three factors: ssn, first name, purpose of controlReason
        if((data.socialSecNumber != null && data.socialSecNumber != "" && data.socialSecNumber != undefined) 
            && (data.firstName != null && data.firstName != "" && data.firstName != undefined)
            && (data.purposeOfControl != null && data.purposeOfControl != "" && data.purposeOfControl != undefined)) {
            // suppress error and accept that we did not find the person
            // This will allow the user to further work with the imported entity
            this.personError[index] = false;
        } else {
            // If we get too many errors in our read-in answer we wont allow it to be worked further with
            this.personError[index] = true;
        }
    }

    setStatus(data, index) {
        if(data) {
            this.arrayOfRkForms[index] = JSON.parse(data);
            //this.personService.getPersonBySsn(this.arrayOfRkForms[index].socialSecNumber).subscribe(
            this.personService.getPersonByIdentityNumber(this.arrayOfRkForms[index].socialSecNumber).subscribe(
                data => this.setPerson(data, index),
                error => this.insufficientDataFromPerson(index, this.arrayOfRkForms[index])
            );
            if(this.arrayOfRkForms[index].employerOrgNr) {
                this.employerService.getEmployerByOrgId(this.arrayOfRkForms[index].employerOrgNr, 'SE').subscribe(
                    data => this.setEmployer(data, index),
                    error => this.noEmployerFound(index)
                );
            } else {
                this.noEmployerFound(index);
            }
        } else {
            this.errorInOcr[index] = true;
        }
    }

    /**
     * Compares specific person values of the imported file with the values stored
     * in the system. If there are differences the conflict handler modal is displayed, 
     * allowing the user to handle the conflicts.
     * @param rkForm An rk form.
     * @param person A person entity.
     */
    comparePersonData(rkForm: any, person: any) {
        const importConflicts: Array<ImportConflict> = [];
        const importedPerson = this.getImportedPersonData(rkForm);

        // Check for mismatches
        let importConflict: ImportConflict;
        if (importedPerson.firstName !== person.firstName) {
            importConflict = new ImportConflict(this.i18.person.form.personFirstNameLabel, importedPerson.firstName, person.firstName, 'firstName');
            importConflict.setValidators([Validators.required, Validators.minLength(2)]);
            importConflicts.push(importConflict);
        }
        const middleNameBlank = importedPerson.middleName === '' && person.middleName == null  // Middlename is null on saved persons that has never had a middlename, but imported middlename is empty string if blank
        if (!middleNameBlank && importedPerson.middleName !== person.middleName) {
            importConflict = new ImportConflict(this.i18.person.form.personMiddleNameLabel, importedPerson.middleName, person.middleName, 'middleName');
            importConflicts.push(importConflict);
        }
        if (importedPerson.lastName !== person.lastName) {
            importConflict = new ImportConflict(this.i18.person.form.personLastNameLabel, importedPerson.lastName, person.lastName, 'lastName');
            importConflict.setValidators([Validators.required, Validators.minLength(2)]);
            importConflicts.push(importConflict);
        }
        if (importedPerson.personPhoneNumber !== person.personPhoneNumber) {
            importConflict = new ImportConflict(this.i18.person.form.personPhoneLabel, importedPerson.personPhoneNumber, person.personPhoneNumber, 'personPhoneNumber');
            importConflict.setValidators([Validators.required, Validators.minLength(5), Validators.pattern(new RegExp("^[+\\d ]+[+\\d -]+[\\d\\s]$"))]); // Regexp copied from person formvalidator
            importConflicts.push(importConflict);
        }

        let concatinateNationalities = importedPerson.nationality;
        if (importedPerson.oldCitizenship.length > 0) {
            concatinateNationalities += "," + importedPerson.oldCitizenship;
        }
        concatinateNationalities = this.checkCountryCodes(concatinateNationalities);

        if (concatinateNationalities !== person.nationalityCode) {
            importConflict = new ImportConflict(this.i18.person.form.personNationalityLabel, concatinateNationalities, person.nationalityCode, 'nationalityCode');
            importConflict.setValidators([Validators.required, Validators.minLength(2), Validators.pattern(new RegExp("^(\\w{2})(,\\w{2})*$"))]);
            importConflicts.push(importConflict);
        }

        // Let user handle mismatches
        if (importConflicts.length > 0) {
            this.conflictHandlerModal.setConflicts(importConflicts);
            this.conflictHandlerModal.pop()
        }        
    }

    /**
     * Closes the rk modal, since no changes are allowed if there are conflicts.
     */
    handleConflictCancel() {
        this.ngxSmartModalService.getModal('rkModal').close();
    }

    /**
     * Handles the resolved conflicts. If any value has been set to use the value from the file, instead
     * of the system value, the person is updated. Else, the modal is closed.
     * @param resolvedConflicts A list of resolved conflicts.
     */
    handleResolvedConflicts(resolvedConflicts: Array<ImportConflict>) {
        let valuesChanged: boolean = false;
        let validCountrycode: boolean = true;
        let clonedPerson = JSON.parse(JSON.stringify(this.person)); // Copy without reference

        resolvedConflicts.forEach(resolvedConflict => {
            if (clonedPerson[resolvedConflict.propertyName] == null && resolvedConflict.resolution === '') {
                // Do nothing
            } 
            else if (clonedPerson[resolvedConflict.propertyName] !== resolvedConflict.resolution) {
                if(resolvedConflict.propertyName == "nationalityCode") {
                    resolvedConflict.resolution = resolvedConflict.resolution.toUpperCase();
                    let splitStr = resolvedConflict.resolution.split(',');
                    for(let i=0; i<splitStr.length; i++) {
                        if(!this.countries.isValidCountryCode(splitStr[i])) {
                            validCountrycode = false;
                            break;
                        }
                    }
                }

                clonedPerson[resolvedConflict.propertyName] = resolvedConflict.resolution;
                valuesChanged = true;
            }
        })

        if (!validCountrycode) {
            this.conflictHandlerModal.displayError(this.i18.conflict.displayError1);
        } else if (valuesChanged) {
            this.updatePerson(clonedPerson);
        }
        else {
            this.conflictHandlerModal.close();
        }
    }

    /**
     * Updates the person by calling backend, then patches the form with the new person data.
     * @param person A person entity.
     */
    private updatePerson(person: any) {
        // Use only some of the Person properties, as done in updatePerson() in the person.form.component.ts file.
        // Some properties are nulled, also as done in the mentioned file.
        let personToUpdate = {
            addresses: person.addresses,
            employers: person.employers,
            fellowApplicants: person.fellowApplicants,
            firstName: person.firstName,
            gender: person.gender,
            id: person.id,
            lastName: person.lastName,
            middleName: person.middleName,
            nationalityCode: person.nationalityCode,
            noSsn: person.noSsn,
            passportNumber: person.passportNumber,
            personPhoneNumber: person.personPhoneNumber,
            securityAgreements: person.securityAgreements,
            ssn: person.ssn,
            coordinationNumber: person.coordinationNumber,
            orgAssociations: person.orgAssociations
        }
        for (let employer of personToUpdate.employers) {
            employer.projectList = null;
            employer.notes = null;
        }

        // Update
        this.personService.updatePerson(personToUpdate, null, null).subscribe(
            data => {
                this.person = data;
                this.patchPersonFields(this.person);
                this.conflictHandlerModal.close();
            },
            error => this.conflictHandlerModal.displayError(error)
        );
    }

    getImportedPersonData(rkForm: any): any {
        const names: Array<string> = rkForm.firstName.split(' ')
        let firstName = names[0].trim();
        let middleName = names.length > 1 ? names.slice(1, names.length).join(' ').trim() : '';

        const importedPerson = {
            firstName,
            middleName,
            lastName: rkForm.lastName.trim(),
            personPhoneNumber: rkForm.phoneNumber.trim(),
            nationality:  rkForm.nationality.trim(),
            oldCitizenship: rkForm.oldCitizenship.trim(),
        }
        return importedPerson;
    }

    noEmployerFound(index) {
        // this.errorInOcr[index] = true;  
        // Ful lösning för att det ska gå fort här, annars hade vi behövt skriva om hanteringen
        this.arrayOfEmployers[index] = undefined;
        this.arrayOfProjects[index] = undefined;

        this.personDetailsForm.patchValue({suaAssignment:'false'}); 
        this.progressArray[index] = 100;
        this.modalIsReady = true;
    }

    removeFile(item, index) {
        if(!this.uploadStarted) {
            return;
        }
        this.confirmService.confirm(this.i18.import.form.confirmRemoveFromList + item.file.name)
            .then(result => {
                if (result) {
                    this.service.deleteFile(item.file).subscribe(
                        data => this.removeFromList(index),
                        error => this.showError(error.error)
                    );
                }
            }); 
    }

    /**
    * Show error
    * @param error error text
    */
    showError(error: any): void {
        if(this.showXmlImportResultView){
            this.cancelXmlUpload();
        } 
        this.confirmService.error(this.appService.getTranslatedErrorMessage(error));        
    }

    showErrorMessage(errorMessage) {
        this.confirmService.error(errorMessage);
    }

    showUpdateStatus(data){
        if(data > 0){
            this.ngxSmartModalService.setModalData(data, 'statusModal', true);
            this.ngxSmartModalService.getModal('statusModal').open();
        }
    }

    redirect(){
        this.dataImported = false;
        this.currentFileUpload = null;
    }

    disablePersonFields() {
        this.personDetailsForm.get('ssn').disable();
        this.personDetailsForm.get('personFirstName').disable();
        this.personDetailsForm.get('personLastName').disable();
        this.personDetailsForm.get('currentCitizenship').disable();
        this.personDetailsForm.get('displayOldCitizenship').disable();
        this.personDetailsForm.get('phoneDaytime').disable();
    }

    enablePersonFields() {
        this.personDetailsForm.get('ssn').enable();
        this.personDetailsForm.get('personFirstName').enable();
        this.personDetailsForm.get('personLastName').enable();
        this.personDetailsForm.get('currentCitizenship').enable();
        this.personDetailsForm.get('phoneDaytime').enable();
    }

    showRkModal(index) {
        this.personSaved = false;
        this.rkToDisplay = this.arrayOfRkForms[index];
        this.person = this.arrayOfPersons[index];
        this.employers = this.arrayOfEmployers[index];
        this.projects = this.arrayOfProjects[index];

        if (!this.person) {
            for (var i = 0; i < this.arrayOfSavedPersons.length; i++) {
                if (this.rkToDisplay.socialSecNumber === this.arrayOfSavedPersons[i].ssn) {
                    this.person = this.arrayOfSavedPersons[i];
                    this.arrayOfPersons[index] = this.arrayOfSavedPersons[i];
                }
            }
        }
        if(this.person){
            this.personSaved = true;
            if((this.person.ssn != null && this.person.ssn !== '') 
                || (this.person.coordinationNumber != null && this.person.coordinationNumber !== '')) {
                this.disablePersonFields();
                this.comparePersonData(this.rkToDisplay, this.person)
                this.patchPersonFields(this.person);
            }
        } else {
            this.enablePersonFields();
            this.personDetailsForm.patchValue({
                ssn: this.rkToDisplay.socialSecNumber,
                personFirstName: this.rkToDisplay.firstName,
                personLastName: this.rkToDisplay.lastName,
                currentCitizenship: this.rkToDisplay.nationality,
                phoneDaytime: this.rkToDisplay.phoneNumber
            });

             // Set values in MAT-select nationality

            let oldCitizenship = this.checkCountryCodes(this.rkToDisplay.oldCitizenship);
            let countryCodes = oldCitizenship.split(',');

            for(let countryCode of countryCodes) {
                this.selectedCountryList.push(countryCode);
            }

            this.nationalityHandler({value: this.selectedCountryList});
            this.nationality.setValue(this.selectedCountryList);
        }

        if(this.employers != null && this.employers.length > 0) {
                this.suaAvailable = true;
                this.personDetailsForm.patchValue({
                    suaAssignment:'true',
                    selectedCompany: null
            }); 
                this.personDetailsForm.get('companySupplier').disable();
                this.personDetailsForm.get('companySuaProject').disable()
        } else {
            this.personDetailsForm.patchValue({suaAssignment:'false'});
            this.personDetailsForm.get('companySupplier').enable();
            this.personDetailsForm.get('selectedCompany').enable();
            if(this.personSaved){
                this.disableCustomerEmployerFields();
            } else {
                this.enableCustomerEmployerFields();
                //to default on scm customer
                this.personDetailsForm.patchValue({employedByCustomer: true});
            }
            this.setEmployerToCustomer();
            this.suaAvailable = false;
        }
        
        // companySuaProject: this.rkToDisplay.companySuaProject,
        this.personDetailsForm.patchValue({
            orgNrOperator: this.rkToDisplay.orgNrOperator,
            operatorName: this.rkToDisplay.operatorName,
            adressCodeOperator: this.rkToDisplay.adressCodeOperator,
            orgNrRegulator: this.rkToDisplay.orgNrRegulator,
            regulatorName: this.rkToDisplay.regulatorName,
            addressCodeRegulator: this.rkToDisplay.addressCodeRegulator,

            purposeOfControl: this.rkToDisplay.purposeOfControl,
            profession: this.rkToDisplay.profession,

            birthplace: this.rkToDisplay.birthplace,
            reasonText: this.rkToDisplay.reasonText,
            latestAddressAbroad: this.rkToDisplay.latestAddressAbroad,
            controlReason: this.rkToDisplay.controlReason,
            rkClassification: this.rkToDisplay.rkClassification,

            otherPostalCity: this.rkToDisplay.otherPostalCity,
            otherPostalCode: this.rkToDisplay.otherPostalCode,
            passportNumber: this.rkToDisplay.passportNumber,
            addressField1: this.rkToDisplay.addressField1,
            addressField2: this.rkToDisplay.addressField2,
            otherPostalAddress: this.rkToDisplay.otherPostalAddress,
            securityInterview: this.rkToDisplay.securityInterview,
            generateSequenceNumber: this.rkToDisplay.generateSequenceNumber,
            nameClarification: this.rkToDisplay.nameClarification,

            countryOfBirthAbroad: this.rkToDisplay.countryOfBirthAbroad,
            otherAddress: this.rkToDisplay.otherAddress,
            addressField3: this.rkToDisplay.addressField3
        });
        this.personDetailsForm.patchValue({
            securityClass: this.rkToDisplay.rkClassification,
            controlReason: this.rkToDisplay.controlReason,
            rkStatus: this.suaStatusType.SENT
        });
        if(!this.personSaved) {
            this.personDetailsForm.patchValue({
                displayOldCitizenship: this.rkToDisplay.oldCitizenship
            });
        }
        if(this.rkToDisplay.lastDate != null && this.rkToDisplay.lastDate.length > 4) {
            if(formatDate(this.rkToDisplay.lastDate, 'yyyy-MM-dd', 'en')) {
                this.personDetailsForm.patchValue({
                    lastDate: formatDate(this.rkToDisplay.lastDate, 'yyyy-MM-dd', 'en')
                });
            }
        } else {
            this.personDetailsForm.patchValue({
                lastDate: null
            });
        }

        this.ngxSmartModalService.setModalData(index, 'rkModal', true);
        this.ngxSmartModalService.getModal('rkModal').open();
    }

    /**
     * Resolve country names by code2
     * @param countryCode
     * @param startIndex
     * @returns
     */
    resolveCountryNames(countryCode: any, startIndex: number) {
        let countryNames = "";
        let countries = countryCode.split(',');
        for(let i=startIndex; i<countries.length; i++) {
            let country = this.countries.get2CountryCodeNames(countries[i].trim());
            if(country != 'None') {
                countryNames += country + ", ";
            }
        }
        countryNames = countryNames.slice(0, -2);
        return countryNames;
    }

    /**
     * Resolve country code2 by names
     * @param countryNames
     * @returns
     */
    resolveCountryCodes(countryNames: any) {
        let countryCodes = "";
        if(countryNames != null) {
            let countries = countryNames.split(',');
            for(let i=0; i<countries.length; i++) {
                let country = this.countries.getCountryFromName(countries[i].trim());
                if(country != undefined) {
                    countryCodes += country.code2 + ",";
                }
            }
            countryCodes = countryCodes.slice(0, -1);
        }
        return countryCodes;
    }

    /**
     * Check if country code is valid and add it to a , separated string
     * @param codes string of country codes 
     * @returns string
     */
    checkCountryCodes(codes: any) {
        let countryCodes = "";
        if(codes != null) {
            let countries = codes.split(',');
            for(let i=0; i<countries.length; i++) {
                let country = countries[i].trim();
                let isValid = this.countries.isValidCountryCode(country);
                if(country != null && country !== '' && isValid) {
                    countryCodes += country + ",";
                }
            }
            countryCodes = countryCodes.slice(0, -1);
        }
        return countryCodes;
    }

    /**
     * Set current and other nationalities
     * @param code2
     * @param type 'current' or 'other'
     * @returns
     */
    setNationalitiesByType(code2: any, type: String) {
        let personNationalityCode = code2.split(',');
        if(type == "current") {
            return personNationalityCode[0].trim();
        } else if(type == "other") {
            let countryCodes = "";
            for(let i=1; i<personNationalityCode.length; i++) {
                countryCodes += personNationalityCode[i].trim() + ",";
            }
            countryCodes = countryCodes.slice(0, -1);
            return countryCodes;
        }
        return "";
    }

    setPerson(person, index) {
        this.arrayOfPersons[index] = person;
        this.personError[index] = false;
    }

    patchPersonFields(person) {
        let firstName;
        if (person.middleName != null) {
            firstName = person.firstName + " " + person.middleName;
        } else {
            firstName = person.firstName;
        }
        this.personDetailsForm.patchValue({
            ssn: person.ssn != null && person.ssn !== '' ? person.ssn : person.coordinationNumber,
            personFirstName: firstName,
            personLastName: person.lastName,
            currentCitizenship: this.setNationalitiesByType(person.nationalityCode, 'current'),
            oldCitizenship: this.setNationalitiesByType(person.nationalityCode, 'other'),
            displayOldCitizenship: this.resolveCountryNames(person.nationalityCode, 1),
            phoneDaytime: person.personPhoneNumber
        });
    }

    setEmployer(employer, index) {
        this.arrayOfEmployers[index] = employer;
        let suaList = [];
        employer.forEach(availableEmployer => {
            if(availableEmployer.projectList !== null && availableEmployer.projectList.length > 0){
                suaList.push(availableEmployer.projectList)
            }
        })
        this.arrayOfProjects[index] = employer.projectList;
        this.progressArray[index] = 100;
        this.modalIsReady = true;
    }

    saveRkModal(index, data) {        
        if(!this.personSaved) {
            return;
        }

        let person = this.arrayOfPersons[index];
        let employer = this.arrayOfEmployers[index];
        let finalRk = data;

        finalRk.personId = person.id;
        /*if(employer) {
            finalRk.employerId = employer.id;
        }*/

        if(this.personDetailsForm.get('generateSequenceNumber').value == undefined){
            finalRk.generateSequenceNumber = false
        } else {
            finalRk.generateSequenceNumber = this.personDetailsForm.get('generateSequenceNumber').value;
        }
        
        finalRk.addressCodeRegulator = this.personDetailsForm.get('addressCodeRegulator').value;
        finalRk.regulatorName = this.personDetailsForm.get('regulatorName').value;
        finalRk.orgNrRegulator = this.personDetailsForm.get('orgNrRegulator').value;
        finalRk.adressCodeOperator = this.personDetailsForm.get('adressCodeOperator').value;
        finalRk.operatorName = this.personDetailsForm.get('operatorName').value;
        finalRk.orgNrOperator = this.personDetailsForm.get('orgNrOperator').value;
        finalRk.rkClassification = this.personDetailsForm.get('securityClass').value;
        finalRk.lastDate = this.dateUpdateFix.fixDateOnUpdate(this.personDetailsForm.get('lastDate').value);
        finalRk.placeholderNationalityCode = this.personDetailsForm.get('currentCitizenship').value;
        finalRk.oldCitizenship = this.personDetailsForm.get('oldCitizenship').value;
        finalRk.otherAddress = this.personDetailsForm.get('otherAddress').value;
        finalRk.otherPostalAddress = this.personDetailsForm.get('otherPostalAddress').value;
        finalRk.otherPostalCity = this.personDetailsForm.get('otherPostalCity').value;
        finalRk.otherPostalCode = this.personDetailsForm.get('otherPostalCode').value;
        finalRk.reasonText = this.personDetailsForm.get('reasonText').value;
        finalRk.rkStatus = this.personDetailsForm.get('rkStatus').value;
        finalRk.securityClass = this.personDetailsForm.get('controlReason').value;
        finalRk.securityInterview = "false";
        finalRk.suaProject = this.personDetailsForm.get('suaAssignment').value;
        finalRk.purposeOfControl = this.personDetailsForm.get('purposeOfControl').value;
        let employerUUID = this.personDetailsForm.get('selectedCompany').value
        if(finalRk.suaProject === 'true' && employerUUID != null && employerUUID !== 'null') {
            finalRk.employerId = employerUUID;
            finalRk.suaId = this.personDetailsForm.get('companySuaProject').value;
        }
        finalRk.status = this.personDetailsForm.get('rkStatus').value;
        finalRk.profession = this.personDetailsForm.get('profession').value;
        finalRk.nameClarification = this.personDetailsForm.get('nameClarification').value;

        finalRk = this.checkRkCountries(finalRk);
        this.rkService.saveRk(finalRk, this.enableDigitalXmlExport).subscribe(
            data => { 
                this.removeFromList(index);
                this.ngxSmartModalService.getModal('rkModal').close();
            },
            error => this.showError(error)           
        );
        
    }

    removeFromList(index) {
        this.progressArray.splice(index, 1);
        this.arrayOfEmployers.splice(index, 1);
        this.errorInOcr.splice(index, 1);
        this.uploadFailed.splice(index, 1);
        this.arrayOfPersons.splice(index, 1);
        this.arrayOfRkForms.splice(index, 1);
        this.arrayOfProjects.splice(index, 1);
        this.personError.splice(index, 1);
        this.uploader.queue[index].remove();
        this.clearForm();

        if(this.uploader.queue.length < 1) {
            this.setDefault();
        }
    }

    /**
     * Merge all nationality codes
     * @param currentCitizenship
     * @param otherCitizenship
     * @returns
     */
    mergeNationalityCodes(currentCitizenship: any, otherCitizenship: any) {
        if (currentCitizenship != null) {
            let nationalityCodes = currentCitizenship;
            if (otherCitizenship !=null && otherCitizenship !== '') {
                nationalityCodes += "," + otherCitizenship;
            }
            return nationalityCodes;
        }
        return null;
    }

    savePerson(index) {
        let employer = this.arrayOfEmployers[index];
        let noSuaAvailable = false;

        let newPerson = {
            fullName: this.personDetailsForm.get("personFirstName").value,
            lastName: this.personDetailsForm.get("personLastName").value,
            nationalityCode: this.mergeNationalityCodes(this.personDetailsForm.get("currentCitizenship").value, this.personDetailsForm.get("oldCitizenship").value),
            passportNumber: this.personDetailsForm.get("passportNumber").value,
            personPhoneNumber: this.personDetailsForm.get("phoneDaytime").value,
            ssn: this.personDetailsForm.get("ssn").value,
            addresses: [],
            employers: null,
            departments: [],
            gender: ""
        };
        if(employer != null && employer.length > 0 && this.checkEmployerFields()) {
            let tmpEmployer = {
                id: this.personDetailsForm.get("selectedCompany").value,
                name: this.personDetailsForm.get("companySupplier").value
            }
            newPerson.employers = [];
            newPerson.employers.push(tmpEmployer);
        } else if(!employer && this.checkEmployerFields()){
            let tmpEmployer = {
                id: this.personDetailsForm.get("selectedCompany").value,
                name: this.personDetailsForm.get("companySupplier").value
            }
            newPerson.employers = [];
            noSuaAvailable = true;
            newPerson.employers.push(tmpEmployer);
        }

        let number = this.personDetailsForm.get("ssn").value.slice(this.personDetailsForm.get("ssn").value.length-2, -1);
          if(number % 2 === 1)
              newPerson.gender = 'MALE';
          else
              newPerson.gender = 'FEMALE';
        this.service.saveNewPerson(newPerson).subscribe(
            event => {
                if(event.status == 200) {
                    this.confirmService.confirm(this.i18.import.form.saveNewPerson1 + ' ' + event.body.ssn + ' ' + this.i18.import.form.saveNewPerson2)
                    .then(result => {
                        if (result) {
                            this.patchPersonFields(event.body);
                            this.disableAndReadyModal(event.body, index);
                            this.person = event.boody;
                            if(noSuaAvailable){
                                this.showEmployerFields = false;
                            }
                        }
                    }); 
                } else if(event.status == 201) {
                    this.person = newPerson;
                    this.arrayOfSavedPersons.push(event.body)
                    this.patchPersonFields(event.body);
                    this.disableAndReadyModal(event.body, index)
                    if(noSuaAvailable){
                        this.disableCustomerEmployerFields();
                    }
                } 
            },
            error => this.showError(error) 
        );          
        
    }

    disableAndReadyModal(data, index) {
        this.arrayOfPersons[index] = data;
        this.disablePersonFields();
        this.personSaved = true;
    }

    setSelected(choice, ssn) {
        for(let i=0; i < this.importedDataList.length; i++) {
            if(this.importedDataList[i].ssn === ssn) {
                for(let n=0;  n < this.importedDataList[i].currentRks.length; n++) {
                    if(this.importedDataList[i].currentRks[n].rkId != choice) {
                        this.importedDataList[i].currentRks.splice(n, 1);
                    }
                }
            }
        }
        this.personsRequireChoice =- 1;
    }

    /**
     * Toggle the generate diary functinality
    */
    customDiaryDisabler() {
        if (this.personDetailsForm.value.generateSequenceNumber) {
            this.personDetailsForm.get('rkInternalRegNumber').disable();
            this.personDetailsForm.patchValue({rkInternalRegNumber: this.i18.rk.form.rkGenerateInternalDiaryNumberPlaceholder});
        } else {
            this.personDetailsForm.get('rkInternalRegNumber').enable();
            this.personDetailsForm.patchValue({rkInternalRegNumber: null});
        }
    }

    /**
     * Get all employers from the backend
     * and populate the filter dropdown list
     */
     getActiveEmployers() {
        this.companyService.getActiveEmployers()
            .subscribe(
                data => {
                    this.setRkOperatorFilterList(data)
                    this.setupEmployers(data)
                },
                error => this.showError(error.error)       
      )
    }

    /**
     * Get all authority employers from the backend
     * and populate the filter dropdown list
     */
     getActiveAuthorityEmployers() {
        this.companyService.getActiveAuthorityEmployers()
            .subscribe(
                data => this.setRkRegulatorFilterList(data),
                error => this.showError(error.error)       
      )
    }


    /**
     * Helper to populate the operator filter list
     * @param data list of employers
     */
    setRkOperatorFilterList(data){
        this.rkOperatorFilterList = data;
    }    

    /**
     * Helper to populate the regulator filter list
     * @param data list of authority type employers
     */
    setRkRegulatorFilterList(data){
        this.rkRegulatorFilterList = data;
    }

    /**
     * Helper to set rk operator organisation id if operator selected from list
     * @param value boolean
     */
     setOperatorValues(value: any) {   
        if(value){
            let operator = this.rkOperatorFilterList.find(operator => operator.name.trim() === this.personDetailsForm.get('operatorName').value);
            this.personDetailsForm.patchValue({
                orgNrOperator: operator.organisationId
            });
            this.formValidator.validateOrgNrOperator(operator.organisationId);            
        } else if (!value && this.rkToDisplay != null && this.personDetailsForm.get('operatorName').value === this.rkToDisplay.operatorName.trim()) {
            this.personDetailsForm.patchValue({
                orgNrOperator: this.rkToDisplay.orgNrOperator
            })
            this.formValidator.validateOrgNrOperator(this.rkToDisplay.orgNrOperator);
        } else if (!value){
            if ((this.personDetailsForm.get('operatorName').value != null && this.personDetailsForm.get('operatorName').value != "" && customerJson.customerGenericValues.customerName != "") && this.personDetailsForm.get('operatorName').value === customerJson.customerGenericValues.customerName) {
                this.personDetailsForm.patchValue({
                    orgNrOperator: this.customerOrgId
                });
                this.formValidator.validateOrgNrOperator(this.customerOrgId);
            } else if (!this.autoClearOrgNrOperator && this.rkToDisplay != null && this.personDetailsForm.get('operatorName').value != null && this.personDetailsForm.get('operatorName').value != ""){
                this.formValidator.validateOrgNrOperator(this.customerOrgId);
            } else {                
                this.personDetailsForm.patchValue({
                    orgNrOperator: null
                });
                //this.formValidator.validateOrgNrOperator("NaN"); // Display red input error 
            }            
        }        
    }

    /**
     * Helper to set rk regulator organisation id if regulator selected from list
     * @param value boolean
     */
     setRegulatorValues(value){
        if(value){
            let regulator = this.rkRegulatorFilterList.find(regulator => regulator.name === this.personDetailsForm.get('regulatorName').value);
            this.personDetailsForm.patchValue({
                orgNrRegulator: regulator.organisationId
            });
        } else if (!value && this.rkToDisplay != null && this.personDetailsForm.get('regulatorName').value === this.rkToDisplay.regulatorName) {
            this.personDetailsForm.patchValue({
                orgNrRegulator: this.rkToDisplay.orgNrRegulator
            })
        } else if (!value){
            this.personDetailsForm.patchValue({
                orgNrRegulator: null
            });
        }
    }

    setCompany(orgid){
        this.employerList.forEach(employer => {
            if(employer.id === orgid){
                this.personDetailsForm.patchValue({
                    selectedCompany: employer.id,
                    companySupplier: employer.name,
                });
            }
        });
    }

    /**
   * Sets the person's employer(s) and toggles the customer tab based on
   * the value of employedByCustomer in the personForm.
   */
    employedByCustomerChanged(): void {
        if (this.personDetailsForm.value.employedByCustomer != null && this.personDetailsForm.value.employedByCustomer == true) {
            this.setEmployerToCustomer()
        } else if(this.personDetailsForm.value.employedByCustomer == null) {
            this.personDetailsForm.patchValue({
                selectedCompany: null,
                companySupplier: null,
            });   
        }
    }

    /**
     * Returns an array containing a single object with the ID of the customer employer.
     */
    setEmployerToCustomer(){
        this.personDetailsForm.patchValue({
            selectedCompany: this.customerEmployer.id,
            companySupplier: this.customerEmployer.name,
        });
    }

    disableCustomerEmployerFields(){
        this.personDetailsForm.get('employedByCustomer').disable();
        this.employerFieldLocked = true;
    }

    enableCustomerEmployerFields(){
        this.personDetailsForm.get('employedByCustomer').enable();
        this.employerFieldLocked = false;
    }

    /**
     * 
     * @param data xml result to display
     */
    setXmlReturnData(data: any){
        this.showLoader = false;
        this.showXmlImportResultView = true;
        this.importedXmlResult = data.body;
        this.importXmlReady = true;
    }

    /**
     * clears the xml result view
     */
    cancelXmlUpload(){
        this.clearData();
        this.showXmlImportResultView = false;
        this.importedXmlResult = [];
        this.selectedFiles = null;
        if(this.xmlUploader != undefined) {
            this.xmlUploader.nativeElement.value = null;
        }
        this.importXmlReady = false;
        this.setOtherType(0);
    }

    /**
     * Set the URL-route to the specified route
     * @param route Route to change to
     */
    setRoute(route) {
        this.appService.setRoute(route);
    }

    getAllAddressCodes() {
        this.rkService.getAllAddressCodes()
        .subscribe(
            data => this.setAddressCodeFilterList(data),
            error => this.showError(error.error)
        );
    }

    /**
     * Set the addressCodes drop-down with existing codes
     * @param data 
     */
    setAddressCodeFilterList(data: any): void {
        this.addressCodeFilterList = data;
    }   

    /**
     * 
     * @param value If written addressCode already exists
     */
    setAddressCodeExists(value){
        this.addressCodeExists = value;
    }

    /**
    * Allows for deletion of an address code
    * This will remove the adress code permanently from the list
    */
     deleteAddressCodeFromList(addressCode): void {
        const addressCodeToDelete = this.addressCodeFilterList.find(code => code.addressCode === addressCode);

        if (addressCodeToDelete) {
            this.confirmService.confirm(`"${addressCodeToDelete.addressCode}" ${this.i18.rk.filterList.rkRemoveFromList}`)
                .then(userWantsToDelete => {
                    if (userWantsToDelete) {
                        this.rkService.deleteAddressCode(addressCodeToDelete.id)
                        .subscribe(
                            data => {
                                this.personDetailsForm.controls.adressCodeOperator.reset();
                                this.setAddressCodeExists(false);
                                this.getAllAddressCodes();
                            },
                            error => this.showError(error.error)
                        );
                    }
                })
        }
        else {
            this.confirmService.error(this.i18.rk.filterList.rkRemoveErrorFromList);
        }
    }

     /**
     * Method that gets a list of unique previously stored professions
     */
      getAllUniqueProfessions(){
        this.rkService.getAllUniqueProfessions()
        .subscribe(
            data => this.setProfessionsFilterList(data),
            error => this.showError(error.error)
        );
    }

    /**
     * Set all unique professions to global variable
     * @param data
     */
    setProfessionsFilterList(data) {
        this.professionsFilterList = data
    }

    /**
    * Allows for deletion of a receiver person
    * This will remove the person permanently from the list
    */
     deleteProfessionFromList(professionName): void {
        const professionToDelete = this.professionsFilterList.find(profession => profession.professionName === professionName);

        if (professionToDelete) {
            this.confirmService.confirm(`"${professionToDelete.professionName}" ${this.i18.rk.filterList.rkRemoveProfessionFromList}`)
                .then(userWantsToDelete => {
                    if (userWantsToDelete) {
                        this.rkService.deleteProfession(professionToDelete.id)
                        .subscribe(
                            data => {
                                this.personDetailsForm.controls.profession.reset();
                                this.setProfessionExists(false);
                                this.getAllUniqueProfessions();
                            },
                            error => this.showError(error.error)
                        );
                    }
                })
        }
        else {
            this.confirmService.error(this.i18.rk.filterList.rkRemoveErrorFromList);
        }
    }

    setProfessionExists(value){
        this.professionExists = value;
    }

    /**
     * Get all employers for a new person, and set customer as employer by default.
     */
    getEmployers() {
        this.personService.getAllEmployers()
        .subscribe(
            data => {
            this.setupEmployers(data)
            this.person.employers = this.setEmployerToCustomer()
            },
            error => this.showError(error.error)       
        )
    }

    /**
     * Set the person's employers as selected and store the different employers in variables.
     * @param employers An array of employers.
     */
    setupEmployers(employers) {
        this.employerList = employers;
        this.customerEmployer = employers.find(employer => employer.organisationId === this.customerOrgId)
    }

    /**
     * Helper to check if defaultregistercontrol countrycodes are 'null'
     * @param rk defaultregistercontrol objekt
     * @returns defaultregistercontrol
     */
    checkRkCountries(rk) {
        if(rk.countryOfBirthAbroad === 'null'){
            rk.countryOfBirthAbroad = null;
        }
        if(rk.oldCitizenship === 'null'){
            rk.oldCitizenship = null;
        }
        if(rk.otherAddress === 'null'){
            rk.otherAddress = null;
        }
        if(rk.addressField3 === 'null'){
            rk.addressField3 = null;
        }
        return rk;
    }

    /**
     * Patch MAT-Select array to nationalityCode in personform
     * @param e Event from mat-select
     */
    nationalityHandler(e:any) {
        let sel = [], tmpsel = [], unsel = []
        this.countries.countries.forEach(item=> {
        if (e.value.indexOf(item.code2) !== -1) {
            tmpsel.push(item);
        } else {
            unsel.push(item);
        }
        })

        for(var i=0; i<e.value.length; i++) {
        tmpsel.forEach(item => {
            if (e.value[i].indexOf(item.code2) !== -1) {
            sel.push(item);
            }
        })
        }

        this.countries.countries = [ ...sel, ...unsel ];

        let countryCodesStr = "";
        for(let code of sel) {
        countryCodesStr += code.code2 +',';
        }
        countryCodesStr = countryCodesStr.slice(0, -1);
        // Country code string store to db cant be bigger than 255 in length
        if (countryCodesStr.length > 255) {
        countryCodesStr = countryCodesStr.slice(0, -3);
        }
        this.personDetailsForm.patchValue({oldCitizenship: countryCodesStr});
        this.personDetailsForm.patchValue({displayOldCitizenship: this.checkCountryCodes(this.resolveCountryNames(countryCodesStr, 0))});
    }

    /**
     * Sets the project list according to which employer is selected
     * @param employerId 
     */
    changeSuaEmployer(employerId) {
        if(employerId != null && employerId !=='null'){
            let currentEmployer = this.employers.find(employer => employer.id === employerId);
            this.projects = currentEmployer.projectList;
            this.personDetailsForm.get('companySuaProject').enable()
            this.personDetailsForm.patchValue({
                companySupplier: currentEmployer.name,
            });
        } else {
            this.personDetailsForm.patchValue({
                selectedCompany: null,
                companySupplier: null,
                companySuaProject: null
            })
            this.personDetailsForm.get('companySuaProject').disable()
        }
    }


    /**
     * clear the rk form on close
     */
    clearForm(){
        this.employers = [];
        this.projects = [];
        this.personDetailsForm.patchValue({
            selectedCompany: null,
            companySupplier: null,
            companySuaProject: null,
            displayOldCitizenship: null,
            oldCitizenship: null
        })
        this.nationality.setValue(null);
        this.selectedCountryList = [];
    }

    /**
     * Helper to check if a employer have been selected for the person
     * @returns boolean
     */
    checkEmployerFields(){
        if((this.personDetailsForm.get("companySupplier").value != null && this.personDetailsForm.get("companySupplier").value !== 'null') 
            && (this.personDetailsForm.get("selectedCompany").value != null && this.personDetailsForm.get("selectedCompany").value !== 'null')){
                return true;
        } else {
            return false;
        }
    }
    
    /**
     * Helper to autocomplete a date with missing dividers '-'
     * @param date date string to patch
     * @param form the form to use
     * @param formControlName the formControlName to be patched with the date.
     */
    patchDate(date: string, form: string, formControlName: string) {
        if(date != null) {
            date = date.replace(/-/g,'');
        }
        if((date != null && date.trim() !== '') && 
        (formControlName != null && formControlName.trim() !== '') && date.length >= 8) {
            let yearPossition = 4;
            let monthPossition = 6;
            let dateDivader = '-'
            let patchedDate = date.substring(0,yearPossition) + dateDivader + date.substring(yearPossition, monthPossition) + dateDivader + date.substring(date.length-2, date.length)
            if(form === 'personDetailsForm') {
                this.personDetailsForm.patchValue({
                    [formControlName]: patchedDate
                })
            }
        }
    }
    
    /**
     *  Set other type
     *  @param type type of page
     */
     setOtherType(type:number) {
        this.otherType = otherTypeEnum[type];
    }
    
    originalOrder = (a: KeyValue<number,string>, b: KeyValue<number,string>): number => {
        return 0;
    }

    printdiv(divId, description, fileName) {
        let printTable = (<HTMLInputElement>this.document.getElementById(divId)).innerHTML;
        let printwin = window.open('','','height=400, width=800');

        printwin.document.write('<html><head><title>' + this.i18.import.xml.importPrintHeader + '</title>');
        printwin.document.write('<style>' + this.printStyling.getDigitalImportExportCss() + '</style>');
        printwin.document.write('</head><body><h1>' + description + '</h1><br >');
        printwin.document.write('<small class="form-text text-muted">' + fileName + '</small>');
        printwin.document.write(printTable);
        printwin.document.write('<script type="text/javascript">addEventListener("load", () => { print(); close(); })</script>')
        printwin.document.write('</body></html>');
        printwin.document.close();
    }
}